export default __webpack_public_path__ + "static/media/work-2.d16c86db.jpg";